<div class="flex flex-col bg-card overflow-hidden">
  <div
    class="pl-3 pr-3 pt-2 pb-2 border-b flex items-center"
    appAccountColorBackground
    #backgroundDirective="appAccountColorBackground"
    [colorName]="panelDef?.color"
  >
    <div class="flex items-center flex-auto" *ngIf="changeTitleMode">
      <app-form-field [fieldDef]="titleFieldDef" [model]="project" (onUpdate)="update($event)"></app-form-field>
    </div>
    <div class="flex flex-col">
      <div
        *ngIf="!changeTitleMode"
        class="font-bold text-md text-secondary uppercase tracking-wider"
        [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
      >
        {{ panelDef.title }}
      </div>
    </div>
    <div class="ml-auto">
      <button
        *ngIf="!readonly && !changeTitleMode"
        mat-icon-button
        type="submit"
        (click)="syncEmails()"
        style="position: relative"
        [ngClass]="{ 'sync-img': isSyncing }"
        [matTooltip]="'Sync'"
      >
        <mat-icon
          [svgIcon]="'sync'"
          [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
        ></mat-icon>
      </button>

      <ng-container *ngIf="canEditPanelDef">
        <button *ngIf="!changeTitleMode" mat-icon-button type="button" [matMenuTriggerFor]="listCardMenu">
          <mat-icon
            class="icon-size-20"
            [svgIcon]="'more_vert'"
            [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
          ></mat-icon>
        </button>
        <mat-menu #listCardMenu="matMenu">
          <button mat-menu-item (click)="toggleChangeTitleMode()" type="button">
            <mat-icon [svgIcon]="'edit'"></mat-icon>
            Change Panel Heading
          </button>
          <button mat-menu-item [matMenuTriggerFor]="toggleLabelMenu" type="button">
            <mat-icon [svgIcon]="'color_lens'"></mat-icon>
            Heading Color
          </button>
          <mat-menu class="mailbox-details-toggle-label-menu-panel" #toggleLabelMenu="matMenu">
            <div
              mat-menu-item
              class="gap-2"
              *ngFor="let color of accountColors$ | async"
              (click)="selectHeaderColor(color.name)"
            >
              <ts-color-bubble [hexColor]="color.hex_value"></ts-color-bubble>
              {{ color.label }}
            </div>
          </mat-menu>
        </mat-menu>
        <button
          class="cancel-button"
          mat-icon-button
          type="button"
          *ngIf="changeTitleMode"
          [matTooltip]="'Cancel'"
          (click)="toggleEditMode(false)"
        >
          <mat-icon
            [svgIcon]="'cancel'"
            [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
          ></mat-icon>
        </button>
        <button *ngIf="changeTitleMode" mat-icon-button type="submit" (click)="saveLayout()" [matTooltip]="'Save'">
          <mat-icon
            [svgIcon]="'save'"
            [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
          ></mat-icon>
        </button>
      </ng-container>
    </div>
  </div>

  <div class="flex flex-col">
    <div class="flex flex-col">
      <mailbox-mail-list
        [relatedToId]="project.id"
        [relatedToType]="'Project'"
        [account]="account"
        [view]="'deal'"
        [(isSyncing)]="isSyncing"
      ></mailbox-mail-list>
    </div>
  </div>
</div>
